import styled from 'styled-components';
import { Circle } from 'rc-progress';
import { TextWithLine } from '../Text';
import { useEffect, useState } from 'react';
import { COLORS } from '../../theme';

export const Container = styled.div`
  width: 100%;
  max-width: 375px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 36px #919db529;
  border: 2px solid #e1eaf3;
  border-radius: 15px;
  opacity: 1;
  box-sizing: border-box;
  padding: 0 1rem;
  @media only screen and (max-width: 1100px) {
    border: 1px solid #e5e8f0;
    box-shadow: 0 0;
  }
  @media only screen and (max-width: 1000px) {
    max-width: 100%;
  }
`;

export const Text = styled.p`
  text-align: left;
  font: normal normal 600 16px/25px Poppins;
  letter-spacing: 0px;
  color: #111723;
  margin-left: 1rem;
  opacity: 1;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 158px;
  height: 158px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 57px #919db529;
  opacity: 1;
  border-radius: 100%;
  position: relative;

  @media (max-width: 440px) {
    width: 135px;
    height: 135px;
  }
`;

const CircleText = styled.p`
  text-align: left;
  font: normal normal 600 20px/30px Poppins;
  letter-spacing: 0px;
  color: ${COLORS.LIGHT_ACCENT};
  opacity: 1;
  position: absolute;
  top: 50%;
  margin: 0;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const InfoContainer = styled.div`
  & > *:first-child {
    margin-bottom: 1rem;
  }
  margin: auto;
`;

const StyledCircle = styled(Circle)`
  height: 130px;
  width: 130px;

  @media (max-width: 440px) {
    width: 115px;
    height: 115px;
  }
`;

type Props = {
  sales: number;
  sellerLevel: {
    id: string;
    name: string;
    feePercentage: number;
    salesRequired: number;
  };
  nextSellerLevel?: {
    id: string;
    name: string;
    feePercentage: number;
    salesRequired: number;
  };
};

export const SellerProfile = (props: Props) => {
  const [percent, setPercent] = useState(0);
  const finalPercent = props.nextSellerLevel
    ? (props.sales / props.nextSellerLevel.salesRequired) * 100
    : 100;

  useEffect(() => {
    setTimeout(() => {
      if (percent < finalPercent) {
        setPercent(percent + 1);
      }
    }, 5);
  }, [percent]);
  return (
    <Container>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div className="mt-4 pr-2">
          <Text className="mb-2">Seller Profile</Text>

          <CircleContainer>
            <StyledCircle
              className="h-fit overflow-visible"
              percent={90}
              strokeWidth={10}
              trailWidth={10}
              trailColor="#F2F5F9"
              strokeColor={COLORS.LIGHT_ACCENT}
              strokeLinecap="square"
            />
            <CircleText>Level {props.sellerLevel.name}</CircleText>
          </CircleContainer>
        </div>
        <InfoContainer>
          <TextWithLine title={String(props.sales)} subtitle="Sales" />
          <TextWithLine
            title={`${props.sellerLevel.feePercentage}%`}
            subtitle="Transaction Fee"
          />
        </InfoContainer>
      </div>
    </Container>
  );
};
